module.exports = __webpack_public_path__ + "img/akitogogon-3.453eb3ac.jpg";